import { render, staticRenderFns } from "./CartButtonsWebCopy.vue?vue&type=template&id=fe3bada6"
import script from "./CartButtonsWebCopy.vue?vue&type=script&lang=js"
export * from "./CartButtonsWebCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports